"use client";

import React from "react";

export default function JerukLimauPage() {
  return (
    <div style={{ width: "100vw", height: "100vh", overflow: "hidden", margin: 0, padding: 0, background: "#000" }}>
      <iframe
        src="/models/jeruk-limau/jeruk-trajaya.html"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          display: "block",
        }}
        title="Lime Try Jaya - Pioneer Field"
      />
    </div>
  );
}
